"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureBuyEpic = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _Core = _interopRequireDefault(require("../Core"));
var _SpinRequest = require("../../dovahzul/requests/SpinRequest");
var _types = require("../balance/types");
var _types2 = require("../com/types");
var _types3 = require("../game/types");
var _types4 = require("../ui/types");
var _DetermineIfNewRoundCanBestarted = require("../../common/helpers/DetermineIfNewRoundCanBestarted");
var _types5 = require("./types");
var _types6 = require("../blitz/types");
var _types7 = require("../autoPlay/types");
var _types8 = require("../promotion/types");
var _ = require("../../..");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FeatureBuyEpic = exports.FeatureBuyEpic = /*#__PURE__*/_createClass(function FeatureBuyEpic() {
  var _this = this;
  _classCallCheck(this, FeatureBuyEpic);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.startFeatureBuyRoundEpic, _this.featureBuyDialogToggle, _this.roundStartRoundEnd, _this.closeDialogIfOpen, _this.promotionHandle, _this.roundVoid);
  });
  _defineProperty(this, "startFeatureBuyRoundEpic", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types5.BUY_FEATURE), (0, _operators.filter)(function () {
      return (0, _DetermineIfNewRoundCanBestarted.DetermineIfNewRoundCanBeStartedNoBalanceCheck)(store.value) && store.value.featureBuy.currentFeatureTrigger != undefined;
    }), (0, _operators.mergeMap)(function (a) {
      // check balance or do a block.
      if (store.value.bet.centValue * store.value.featureBuy.currentFeatureTrigger.betMulitiplier > store.value.balance.balance.centValue) {
        return (0, _rxjs.of)({
          type: _types4.DIALOG_STATE,
          payload: _.DialogState.INSUFFICIENT_BALANCE
        });
      }

      // If we are currently disconnected, we wait for a success full reconnect than re trigger the start.
      if (store.value.com.connectionState === _types2.ConnectionState.Reconnecting) {
        console.warn("reconnecting");
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types4.STATUS_TEXT_SET,
          payload: {
            value: _Core["default"].translate("reconnecting")
          }
        }), (0, _rxjs.of)({
          type: _types5.BUY_FEATURE
        }), action$.pipe((0, _reduxObservable.ofType)(_types2.RECONNECTED), (0, _operators.take)(1), (0, _operators.mapTo)({
          type: _types5.BUY_FEATURE,
          payload: a.payload
        })));
      }
      var meta = a.payload ? a.payload.roundMetaData : {};
      meta.autoPlay = store.value.autoPlay.on;
      var bet = store.value.bet;
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types2.COMMAND_SEND,
        payload: new _SpinRequest.SpinRequest(bet.coins, bet.lines, bet.denomination, meta, store.value.featureBuy.currentFeatureTrigger.id, bet.featureSet)
      }), (0, _rxjs.of)({
        type: _types5.CLOSE_FEATURE_BUY
      }), (0, _rxjs.of)({
        type: _types3.ROUND_START
      }), (0, _rxjs.of)({
        type: _types5.FEATURE_BOUGHT
      }),
      //    of({ type: REELS_SPIN }),
      (0, _rxjs.of)({
        type: _types.UPDATE_BALANCE_BET_FEATURE_BUY,
        payload: store.value.featureBuy.currentFeatureTrigger.betMulitiplier
      }));
    }));
  });
  _defineProperty(this, "featureBuyDialogToggle", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types5.REQUEST_FEATURE_BUY_TOGGLE),
    // only allow it to open if its
    (0, _operators.filter)(function () {
      var _store$value$featureB;
      return ((_store$value$featureB = store.value.featureBuy) === null || _store$value$featureB === void 0 || (_store$value$featureB = _store$value$featureB.availableFeatures) === null || _store$value$featureB === void 0 ? void 0 : _store$value$featureB.length) > 0 && (0, _DetermineIfNewRoundCanBestarted.DetermineIfNewRoundCanBeStartedNoBalanceCheck)(store.value);
    }), (0, _operators.mapTo)({
      type: _types5.TOGGLE_FEATURE_BUY
    }));
  });
  _defineProperty(this, "promotionHandle", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types8.PROMOTION_START, _types8.PROMOTION_END), (0, _operators.filter)(function () {
      var _store$value$featureB2;
      return (_store$value$featureB2 = store.value.featureBuy) === null || _store$value$featureB2 === void 0 ? void 0 : _store$value$featureB2.enabled;
    }), (0, _operators.mergeMap)(function (a) {
      if (a.type === _types8.PROMOTION_END) return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types5.SHOW_FEATURE_BUY_BUTTON
      }));else return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types5.HIDE_FEATURE_BUY_BUTTON
      }), (0, _rxjs.of)({
        type: _types5.CLOSE_FEATURE_BUY
      }));
    }));
  });
  _defineProperty(this, "roundVoid", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.ROUND_VOID), (0, _operators.filter)(function () {
      var _store$value$featureB3;
      return ((_store$value$featureB3 = store.value.featureBuy) === null || _store$value$featureB3 === void 0 ? void 0 : _store$value$featureB3.enabled) && !store.value.promotion.on;
    }), (0, _operators.mapTo)({
      type: _types5.SHOW_FEATURE_BUY_BUTTON
    }));
  });
  _defineProperty(this, "roundStartRoundEnd", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.ROUND_START, _types3.ROUND_END), (0, _operators.mergeMap)(function (a) {
      if (a.type === _types3.ROUND_END && !store.value.promotion.on) return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types5.SHOW_FEATURE_BUY_BUTTON
      }));else return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types5.HIDE_FEATURE_BUY_BUTTON
      }), (0, _rxjs.of)({
        type: _types5.CLOSE_FEATURE_BUY
      }));
    }));
  });
  /**
   * Various actions that should cause the dialog to close
   */
  _defineProperty(this, "closeDialogIfOpen", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types6.BLITZ_MODE_ON, _types7.AUTO_PLAY), (0, _operators.mapTo)({
      type: _types5.CLOSE_FEATURE_BUY
    }));
  });
});
//# sourceMappingURL=epics.js.map